export type ThemeChoice = 'light' | 'dark' | 'system';

const KEY = 'vds:theme';

export function getThemeChoice(): ThemeChoice {
  try {
    const v = localStorage.getItem(KEY);
    if (v === 'light' || v === 'dark') return v;
  } catch {
    /* storage unavailable */
  }
  return 'system';
}

export function effectiveTheme(choice: ThemeChoice = getThemeChoice()): 'light' | 'dark' {
  if (choice !== 'system') return choice;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function applyTheme(choice: ThemeChoice): void {
  const root = document.documentElement;
  if (choice === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', choice);
  try {
    if (choice === 'system') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, choice);
  } catch {
    /* ignore */
  }
}

export function toggleTheme(): 'light' | 'dark' {
  const next = effectiveTheme() === 'dark' ? 'light' : 'dark';
  applyTheme(next);
  return next;
}

/** Call once at startup so the stored choice applies before first paint. */
export function initTheme(): void {
  applyTheme(getThemeChoice());
}
